import React, { useState, useRef, useEffect } from "react";
import { ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import downloadDi from "@frameworks/web/components/Reports/RebrandedReports/DownloadReports/di/serviceLocator";
import { useSelector } from "react-redux";
import { EReportsURLKeys } from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import Toaster from "./Toaster";
import subscriptionDi from "./di/servicelocator";
const DownloadAndEmail = (props) => {
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const [downloadShow, setDownloadShow] = useState(false);
    const downloadPopupRef = useRef(null);
    const [emailToasterShow, setEmailToasterShow] = useState(false);
    const [downloadToasterShow, setDownloadToasterShow] = useState(false);
    const [downloadToasterSuccess, setDownloadToasterSuccess] = useState(false);
    const [downloadToasterMessage, setDownloadToasterMessage] = useState("");
    const [emailToasterMesssage, setEmailToasterMessage] = useState("");
    const [emailToasterSuccess, setEmailToasterSuccess] = useState(false);
    const handleDownloadClick = () => {
        setDownloadShow(!downloadShow);
    };
    const handleDownloadExcelOrPdf = (reportType) => {
        handleDownloadClick();
        let emailPayload, downloadPayload = null;
        downloadPayload = {
            method: "GET",
            reportType,
            searchParams: [
                {
                    key: "accountId",
                    value: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
                },
                {
                    key: "schemeRefNo",
                    value: props === null || props === void 0 ? void 0 : props.schemeRefNo,
                },
            ],
            urlParts: {
                firstPart: EReportsURLKeys.SUBSCRIPTION,
                secondPart: "/rateBasedConsumption",
            },
        };
        downloadDi.downloadReport
            .downloadAndSendReport(emailPayload, downloadPayload)
            .then((status) => {
            if (status) {
                const reportTypeText = reportType === ReportType.PDF ? "PDF" : "Excel";
                setDownloadToasterMessage(`Your ${reportTypeText} download has been complete`);
                setDownloadToasterShow(true);
                setDownloadToasterSuccess(true);
            }
            else {
                throw new Error();
            }
        })
            .catch(() => {
            const reportTypeText = reportType === ReportType.PDF ? "PDF" : "Excel";
            setDownloadToasterMessage(`Your ${reportTypeText} download was not possible due to a technical error, try again later`);
            setDownloadToasterShow(true);
            setDownloadToasterSuccess(false);
        });
    };
    const handleSendEmail = () => {
        var _a;
        let emailPayload = {
            method: "POST",
            requestBody: {
                accountId: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
                schemeRefNo: props === null || props === void 0 ? void 0 : props.schemeRefNo,
            },
            urlParts: {
                firstPart: EReportsURLKeys.SUBSCRIPTION,
                secondPart: "/rateBasedConsumption",
            },
        };
        (_a = subscriptionDi.subscriptionReport) === null || _a === void 0 ? void 0 : _a.emailSubscriptionPopup(emailPayload).then((res) => {
            var _a;
            if (!res || !(res === null || res === void 0 ? void 0 : res.status) || ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status)) {
                const match = res.data.message.match(/\S+@\S+/);
                let emailId;
                if (match) {
                    emailId = match[0];
                }
                else {
                    throw new Error();
                }
                setEmailToasterMessage(`Report has been mailed to ‘${emailId}’`);
                setEmailToasterShow(true);
                setEmailToasterSuccess(true);
            }
            else {
                throw new Error();
            }
        }).catch(() => {
            setEmailToasterMessage("Mailing this report is not possible due to some technical error, try again");
            setEmailToasterShow(true);
            setEmailToasterSuccess(false);
        });
    };
    function handleClickOutside(event) {
        if (downloadPopupRef.current &&
            !downloadPopupRef.current.contains(event.target))
            setDownloadShow(false);
    }
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [downloadPopupRef]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex gap-10 justify-content-end subscription-downloadEmail-parent" },
            React.createElement("div", { ref: downloadPopupRef, className: "position-relative" },
                React.createElement("div", { className: "download-icon-div", onClick: handleDownloadClick },
                    React.createElement("i", { className: "edel-icon-download-coloured" },
                        React.createElement("span", { className: "path1" }),
                        React.createElement("span", { className: "path2" }))),
                downloadShow && (React.createElement("div", { className: "download-popup" },
                    React.createElement("div", { className: "download-popup-txt-div", onClick: () => handleDownloadExcelOrPdf(ReportType.PDF) }, "Download PDF"),
                    React.createElement("div", { className: "download-popup-txt-div", onClick: () => handleDownloadExcelOrPdf(ReportType.EXCEL) }, "Download Excel"))),
                React.createElement(Toaster, { parentClassName: `subscription_toaster_download success-width ${downloadToasterSuccess ? "success-min-width" : ""}`, success: downloadToasterSuccess, show: downloadToasterShow, setShow: setDownloadToasterShow, message: downloadToasterMessage })),
            React.createElement("div", null,
                React.createElement("div", { className: "email-icon-div gap-2", onClick: () => handleSendEmail() },
                    React.createElement("i", { className: "edel-icon-email-us" }),
                    React.createElement("span", null, " Mail to myself"))),
            React.createElement(Toaster, { parentClassName: "subscription_toaster_email", success: emailToasterSuccess, show: emailToasterShow, setShow: setEmailToasterShow, message: emailToasterMesssage }))));
};
export default DownloadAndEmail;
